import { CreateSupervisorAction } from '../../../libs/GraphQL';
import { DISPATCH_UNREACHABLE_EVENT_TYPE } from '../../../libs/stopStatus';
import { REVIEW_PHASE_DAY_OF } from '../RouteOperations/utils';
import { DISPATCH_REASON } from './dispatchReasons';

// Dispatch-coding is a SupervisorAction only. A LocationUnreachable
// DriverAction is not written: its backend handler requires a packing slip
// and posts a Slack alert per stop, neither of which fits a bulk supervisor
// update. `libs/stopStatus.js` reads these rows into the status ladder.
export const DISPATCH_REVIEW_PHASE = REVIEW_PHASE_DAY_OF;

export function buildDispatchUnreachableInput({
  supervisorEmail,
  stockingDate,
  stop,
  reason,
}) {
  // Omit market / FC when the stop lacks them so filtered reads never match
  // an empty string.
  return {
    ...(stop.fulfillmentCenter && {
      fulfillmentCenter: stop.fulfillmentCenter,
    }),
    ...(stop.market && { market: stop.market }),
    reviewDate: stockingDate,
    reviewPhase: DISPATCH_REVIEW_PHASE,
    eventType: DISPATCH_UNREACHABLE_EVENT_TYPE,
    data: {
      locationId: stop.id,
      routeId: stop.route || '',
      stockingDate,
      reason: DISPATCH_REASON.value,
      subReason: reason.subReason,
      notes: (reason.note || '').trim(),
      supervisorEmail,
    },
  };
}

export async function markStopsUnreachable({
  stops,
  supervisorEmail,
  stockingDate,
  reason,
}) {
  const results = await Promise.all(
    stops.map((stop) =>
      Promise.resolve()
        .then(() =>
          CreateSupervisorAction(
            buildDispatchUnreachableInput({
              supervisorEmail,
              stockingDate,
              stop,
              reason,
            }),
          ),
        )
        .then(
          () => ({ stop, ok: true }),
          (error) => ({ stop, ok: false, error }),
        ),
    ),
  );
  return {
    succeeded: results.filter((r) => r.ok).map((r) => r.stop),
    failed: results
      .filter((r) => !r.ok)
      .map(({ stop, error }) => ({ stop, error })),
  };
}
